import React from 'react';
import { Edit, SimpleForm, TextInput, BooleanInput, ShowButton, regex } from 'react-admin';
import CardActions from "@material-ui/core/CardActions";
import BackButton from '../components/BackButton';
import UserIcon from '@material-ui/icons/AccountCircle';
import AdminIcon from '@material-ui/icons/VerifiedUser';
import EnableIcon from '@material-ui/icons/CheckCircle';
import ContactIcon from '@material-ui/icons/PermPhoneMsg';
import CustomLabelInput from '../components/CustomLabelInput';

function phoneNumberFormat(phoneNumberString) {
    var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
    var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

    if (match) {
        return '(' + match[1] + ') ' + match[2] + '-' + match[3];   
    } else if (phoneNumberString.length >= 14) {
        return phoneNumberString.substring(0, 14);
    } else {
        return phoneNumberString.substring(0, 14);
    } 
}

const UsersEditActions = ({ basePath, data }) => (
    <CardActions>
        <BackButton style={{ marginRight: "auto" }}></BackButton>
        <ShowButton basePath={basePath} record={data} />
    </CardActions>
);

const UserEditGeneral = ({ record }) => {
    return (
        <div className="row row-cols-2 row-cols-lg-3 g-5 g-md-2 g-lg-2">
            <div>
                <TextInput source="display_name" label={<CustomLabelInput label="Display Name"/>} variant="outlined" />
            </div>
        </div>
    );
};

const UserEditContact = ({ record }) => {
    return (
        <div className="row row-cols-3 g-2 g-lg-3">
            <div>
                <TextInput source="phone_number" placeholder="(000) 000-0000" className="w-100" validate={regex(/^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$/, 'Must be (000) 000-0000')} parse={phoneNumberFormat} label={<CustomLabelInput label="Phone"/>} fullWidth variant="outlined" resettable />
            </div>
            <div>
                <TextInput source="email" className="w-100" label={<CustomLabelInput label="Email" />} variant="outlined" />
            </div>
        </div>
    );
};

const UserEditAccess = ({ record }) => {
    return (
        <div className="m-0 mb-3">
            <div className="rounded p-3 pt-2" style={{ border: '1px solid', borderColor: 'rgb(211, 211, 211)' }}>
                <div className="row">
                    <div class="w-25">
                        <h6 className="fw-light text-secondary" style={{ marginBottom: '2px', fontSize: '11px', color: 'rgb(211, 211, 211)' }}>Access</h6>
                        <BooleanInput source="access.user" label="User" options={{
                            icon: <UserIcon />,
                            checkedIcon: <UserIcon />,
                        }} />
                        <BooleanInput source="access.admin" label="Admin" options={{
                            icon: <AdminIcon />,
                            checkedIcon: <AdminIcon />,
                        }} />
                    </div>
                    <div class="w-25">
                        <h6 className="fw-light text-secondary" style={{ marginBottom: '2px', fontSize: '11px', color: 'rgb(211, 211, 211)' }}>Disabled</h6>
                        <BooleanInput source="disabled" label="Disabled" options={{
                            checkedIcon: <EnableIcon />,
                        }} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export const UserEdit = (props) => {
    return (
        <>
            <h3 className="text-danger px-3 px-md-0 pt-3 pt-md-0" style={{ fontFamily: 'Arial, sans-serif' }}>Edit User</h3>
            <Edit title=" " actions={<UsersEditActions />} {...props}>
                <SimpleForm redirect="show">
                    <UserEditGeneral className="mb-3" record={{ ...props }} />
                    <UserEditAccess className="mb-3" record={{ ...props }} />

                    <h6 className="font-weight-normal pt-2">{<ContactIcon className="d-inline text-danger" style={{ fontSize: '28px' }} />} Contact</h6>
                    <UserEditContact record={{ ...props }} />
                </SimpleForm>
            </Edit>
        </>
    )
};

export default UserEdit;